<div class="ui secondary segment">
  <sui-dimmer class="inverted" [(isDimmed)]="pending" isClickable="false">
    <div class="ui text loader">Loading</div>
  </sui-dimmer>
  <div>
    <div *ngIf="success || error" appMargin marginY="10px">
      <esl-message-toast [(message)]="error"></esl-message-toast>
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
    </div>

    <div
      id="scrollMe"
      infinite-scroll
      [scrollWindow]="false"
      [infiniteScrollUpDistance]="2"
      (scrolled)="onScrollDown($event)"
      (scrolledUp)="onScrollUp($event)"
      appPadding="0"
      class="scroll-wrapper ui basic segment"
      [ngClass]="{ loading: pending }"
    >
      <div *ngFor="let comment of messages">
        <app-comment-message
          [complaintId]="complaintId"
          [msg]="comment"
          (reply)="onReply($event)"
        >
        </app-comment-message>
      </div>
    </div>
    <!-- <div style="text-align: center" *ngIf="newComment">
						<div class="ui basic compact orange button" (click)="showNewComment()">show new comments</div>
							</div> -->
  </div>
  <div
    appPadding="0px"
    appMargin
    marginX="30px"
    marginT="20px"
    class="ui basic segment"
    *ngIf="isReply"
  >
    <div appPadding="0px" class="ui basic segment" id="reply-block">
      <div
        class="ui circular red tiny right floating label"
        (click)="removeReply()"
      >
        <i appMargin="0px" class="cancel icon"></i>
      </div>
      <div appMargin="0px" class="ui segment">
        <app-comment-message
          [complaintId]="complaintId"
          isReply="true"
          [msg]="isReply"
        >
        </app-comment-message>
      </div>
    </div>
    <div class="ui form" [formGroup]="replyForm">
      <div
        class="field"
        fxLayout="row"
        fxLayoutGap="3px"
        fxLayoutAlign="space-between end"
      >
        <div class="field" fxFlex="grow">
          <div
            class="content-area"
            contenteditable
            formControlName="comment"
            placeholder="Enter comment..."
          ></div>
        </div>
      </div>
      <div
        *isPermitted="{ id: 'CHAT', action: 'add' }"
        class="field"
        fxLayout="row"
        fxLayoutGap="3px"
        fxLayoutAlign="space-between center"
      >
        <div fxFlex="10%">
          <button class="ui tiny icon button" (click)="uploadDoc()">
            <i class="file large outline icon"></i>
          </button>
          <!-- <input hidden type="file" #uploader (change)="uploadDoc($event.target.files)"> -->
        </div>
        <!-- <div fxFlex="45%">
										<sui-checkbox
										 [(ngModel)]="replyForm.value.allowContractorToRespond" [ngModelOptions]="{standalone: true}">
												Allow company to respond?
											</sui-checkbox>
										</div> -->
        <div fxFlex class="text-right">
          <button
            class="ui tiny primary button"
            [disabled]="!replyForm.valid"
            (click)="send(isReply.messageId)"
          >
            Send
          </button>
          <button class="ui tiny icon button">
            <i class="ellipsis vertical icon"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="!isReply"
    appMargin
    marginT="10"
    class="ui form"
    [formGroup]="replyForm"
  >
    <div
      class="field"
      fxLayout="row"
      fxLayoutGap="3px"
      fxLayoutAlign="space-between end"
    >
      <div class="field" fxFlex="grow">
        <div
          class="content-area"
          contenteditable
          formControlName="comment"
          placeholder="Enter comment..."
        ></div>
      </div>
    </div>
    <div
      *isPermitted="{ id: 'CHAT', action: 'add' }"
      class="field"
      fxLayout="row"
      fxLayoutGap="3px"
      fxLayoutAlign="space-between center"
    >
      <div fxFlex="10%">
        <button class="ui tiny icon button" (click)="uploader.click()">
          <i class="file large outline icon"></i>
        </button>

        <input
          hidden
          type="file"
          accept=".jpg, .jpeg, .png"
          #uploader
          (change)="uploadDoc($event.target.files)"
          placeholder="Browse for documents"
          onclick="value = null"
        />
      </div>
      <!-- <div fxFlex="35%">
										<sui-checkbox
											 [(ngModel)]="replyForm.value.allowContractorToRespond" [ngModelOptions]="{standalone: true}">
												Allow company to respond?
											</sui-checkbox>
										</div> -->
      <div fxFlex class="text-right">
        <button
          class="ui tiny primary button"
          [disabled]="!replyForm.valid"
          (click)="send('null')"
        >
          Send
        </button>
        <!-- <button class="ui tiny icon button">
											<i class="ellipsis  vertical icon"></i>
											</button> -->
      </div>
    </div>
  </div>
  <div *ngIf="fileObj" class="ui image fluid red label">
    Attachment
    <i class="delete icon" (click)="removeFile()" style="float: right"></i>
  </div>
</div>
